<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-profile"></i> 系统相关</el-breadcrumb-item>
                <el-breadcrumb-item>用户</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container container-content">
            <el-page-header @back="goBack" content="详情页面"></el-page-header>
            <el-divider></el-divider>

            <el-row :gutter="20" style="margin-left: 27px">
                <el-col :span="8">
                    <div class="grid-content"> 
                        <p>Nickname</p>
                        <p class="cont">{{account}}</p>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <p>上次登录</p>
                        <p class="cont">{{this.loginTime}}</p>
                    </div>
                </el-col>
                <el-col :span="4">
                        <!--<el-button type="primary" style="margin-top: 5%" @click="submit()">储 存</el-button>-->
                        <el-button type="primary" style="margin-top: 5%" @click="initPassword()">初始化密码</el-button>
                </el-col>
            </el-row>

<!--            <el-divider content-position="left"><h3 style="color: #303133">项目所属</h3></el-divider>
            <div class="plugins-tips">
                <el-checkbox v-model="checkedCities" @change="checkedAllFun">All</el-checkbox>
            </div>

            <div class="drag-box" v-loading = "divLoading" element-loading-spinner="el-icon-lock">
                <div class="drag-box-item">
                    <div class="item-title">项目</div>
                    <div group="site">
                        <div tag="div" id="projects" class="item-ul">
                            <el-table
                            style="width: 100%"
                            height="400"
                            :data="drag.projects"
                            stripe
                            v-loading = "roleLoading"
                            @selection-change="left_handleSelectionChange"
                            @row-click="left_rowClick"
                            >
                                <el-table-column type="selection" width="55"></el-table-column>
                                <el-table-column prop="cnName" label="全选"></el-table-column>
                                <el-table-column width="65">
                                    <template slot="header">
                                        <div @click="left_selectionClick" style="font-size: 22px; cursor: pointer; color: #606266; width: 100%; text-align: center; margin-right: 25px">   
                                            <i class="el-icon-right" style="width: 13px"/>
                                            &lt;!&ndash; <i class="el-icon-d-arrow-right" style="border-bottom: 1px solid #606366"/> &ndash;&gt;
                                        </div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="drag-box-item">
                    <div class="item-title">所属</div>

                    <div group="site">
                        <div tag="div" id="done" class="item-ul">
                            <el-table
                            ref="singleTable"
                            style="width: 100%"
                            :data="drag.done" 
                            height="400"
                            stripe
                            v-loading = "roleLoading"
                            empty-text = "未分配"
                            @selection-change="right_handleSelectionChange"
                            @row-click="right_rowClick"
                            highlight-current-row
                            @cell-click="right_cellClick"
                            >
                                <el-table-column type="selection"  width="55"></el-table-column>
                                <el-table-column prop="cnName" label="全选"></el-table-column>
                                <el-table-column prop="name"  width="55"   label="" >
                                    <template slot="header" label="111">
                                        <div @click="right_selectionClick" style="font-size: 22px; cursor: pointer; color: #606266; width: 100%; text-align: center; margin-right: 25px">   
                                            <i class="el-icon-back" style=" width: 13px"/>
                                            &lt;!&ndash; <i class="el-icon-d-arrow-left" style="border-bottom: 1px solid #606366"/> &ndash;&gt;
                                        </div>
                                    </template>
                                    <template slot-scope="">
                                        <i class="el-icon-arrow-left" style="font-size: 15px"></i>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>

            <el-divider content-position="left">
                <h3 style="color: #303133">职 位 </h3>
            </el-divider>
            <el-row :gutter="20">
                <el-col :span="20">
                    <div class="grid-content grid-content-posi">
                        <el-checkbox-group 
                            v-model="checkedCities" 
                            @change="checkBox($event)">
                            <el-checkbox v-for="city in cities" :label="city.roleId" :key="city.roleId" :disabled="disabledStores.includes(city.roleId)">{{city.roleName}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </el-col>
            </el-row>

            <el-divider content-position="left"><h3 style="color: #303133">权 限</h3></el-divider>
            
            <el-row :gutter="20">
                <el-col :span="10">
                    <div class="grid-content-perm">
                        <ul>
                            <li v-for="item in permission" :key="item">{{item}}</li>
                        </ul>
                    </div>
                </el-col>
                <el-col :span="10">
                    <div class="grid-content-perm">
                        
                    </div>
                </el-col>
            </el-row>-->

        </div>
    </div>
</template>

<script>
import axios from 'axios';
import http from '../../common/Common.vue';
import { userAdminInitPassword } from '@/components/api/user';
import { message } from '@/utils/message';

export default {
    name: 'basetable',
    data() {
        return {
            query: {
                //account: '',  //搜索框值
                pageIndex: 1,
            },
            loading: true,
            roleLoading: true,
            divLoading : false,
            tableData: [], //el-table集合

            //第一列信息
            account: '',
            userId: '',
            loginTime: '',
            //展示职位列表
            showList: true,
            //展示职位详细
            showContent: false,

            //所属项目
            drag: {
                //项目缓存
                project: '',
                //项目栏
                projects: [],
                //所属栏
                done:[],

                left_multipleSelection: [],  //多选操作
                right_multipleSelection: [],  //多选操作
            },
            //left_项目  全部, all
            checkedAll: false,
            //用于 选中 checkedAll 后,
            disableFlag: false,
            
            //职位多选框
            cities: [],
            disabledStores: [],
            //多选数据 缓存
            checkedCities: [],
            //多选数据 持久化
            checkedList: [],

            //权限所有信息
            permissionInfo: [],
            //拥有的权限
            permissionId: [],
            //过滤后
            permission: [],

            // 当前角色
            roleRow: ''
        }
    },
    created() {
        this.getCities()    //职位
        this.getPermissionInfo() //权限信息
        this.init()
    },
    activated() {
        this.init()
    },
    methods: {
        
        init() {
            this.drag.done = []
            this.checkedList = []

            let roleRow = JSON.parse(localStorage.getItem('roleRow'))
            this.account = roleRow['nickName']
            this.loginTime = roleRow['loginTime']
            this.userId = roleRow['userId']

            // axios.post(http.httpUrl + '/getAntiProjectDataName', null).then((res) =>{
            //     this.drag.projects = res.data
            //     this.roleLoading = false
            // }).catch(err =>{
            //     this.roleLoading = false
            //     this.$message.error('获取项目名称失败')
            // })
        },

        //选中 All
        checkedAllFun() {
            this.checkedAll = !this.checkedAll

            this.divLoading = !this.divLoading
            //All被选中,  禁用 项目所属 div
            if (this.checkedAll == true) {
                this.disableFlag = true
            }
            
            //解禁职位多选框
            this.disabledStores = []
            //如取消选中, 就禁用多选职位框
            if (this.checkedAll == false) {
                //禁用所有多选框,  选择项目信息后解禁
                for (let i = 0; i < this.cities.length; i++) {
                    this.disabledStores.push(this.cities[i].roleId)
                }
            }
        },

        //左 项目框 多选操作
        left_handleSelectionChange(val) {
            this.drag.left_multipleSelection = val
        },

        //左 项目框 row点击事件
        left_rowClick (row) {
            for (let i = 0; i < this.drag.projects.length; i++) {
                if (row.objectId == this.drag.projects[i].objectId) {
                    this.drag.done = this.drag.done.concat(this.drag.projects[i])
                    this.drag.projects.splice(i, 1)
                }
            }
        },

        //左 项目框多选 赋值到 所属框
        left_selectionClick () {
            
            for (let i = 0; i < this.drag.projects.length; i++) {
                for (let j = 0; j < this.drag.left_multipleSelection.length; j++) {
                    if (this.drag.projects[i].objectId == this.drag.left_multipleSelection[j].objectId) {
                        this.drag.done = this.drag.done.concat(this.drag.projects[i])
                        this.drag.projects.splice(i, 1)
                        
                    }
                }
            }
            this.drag.left_multipleSelection = []
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },
        
        //右 所属框 cell点击事件,  
        right_cellClick (row, column) {
            if (column.label == '') {
                for (let i = 0; i < this.drag.done.length; i++) {
                    if (row.objectId == this.drag.done[i].objectId) {
                        this.drag.projects = this.drag.projects.concat(this.drag.done[i])
                        //清除已选职位缓存
                        this.checkedList[this.drag.done[i].objectId] = ['7d3b5b1d9f5811ec9b5652540055af6b']

                        this.drag.done.splice(i, 1)
                    }
                }
            }
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },
        
        //右 所属框多选 赋值到 项目框
        right_selectionClick () {
            for (let i = 0; i < this.drag.done.length; i++) {
                for (let j = 0; j < this.drag.right_multipleSelection.length; j++) {
                    if (this.drag.done[i].objectId == this.drag.right_multipleSelection[j].objectId) {
                        this.drag.projects = this.drag.projects.concat(this.drag.done[i])
                        //清除已选职位缓存
                        this.checkedList[this.drag.done[i].objectId] = ['7d3b5b1d9f5811ec9b5652540055af6b']

                        this.drag.done.splice(i, 1)
                    }
                }
            }
            //清空
            this.drag.right_multipleSelection = []
            
            //禁用所有多选框,  选择项目后解禁
            for (let i = 0; i < this.cities.length; i++) {
                this.disabledStores.push(this.cities[i].roleId)
            }
        },

        //右 所属框 多选操作
        right_handleSelectionChange(val) {
            this.$refs.singleTable.setCurrentRow();

            this.drag.right_multipleSelection = val

            this.drag.project = val.objectId    //将当前点击的project保存  
            //持久化数据不为空
            if (undefined !== this.checkedList[val.objectId]) {
                
                //清空临时数据
                this.checkedCities = []
                //临时数据  >>>   持久化数据
                this.checkedCities = this.checkedList[val.objectId]
                
            } else {
                this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b']
            }
            //点击选择项目后，解禁职位多选框
            this.disabledStores = []
            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //点击 所属框 的项目
        right_rowClick(row, column) {
            if (column.label == '') {
                return false 
            }

            this.drag.project = row.objectId    //将当前点击的project保存  
            //持久化数据不为空
            if (undefined !== this.checkedList[row.objectId]) {
                
                //清空临时数据
                this.checkedCities = []
                //临时数据  >>>   持久化数据
                this.checkedCities = this.checkedList[row.objectId]
                
            } else {
                this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b']
            }
            //点击选择项目后，解禁职位多选框
            this.disabledStores = []
            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //查询所有职位
        getCities() {
            // axios.post(http.httpUrlRegAndLogin + 'getAllRolesInfo', null).then(res => {
            //     let data = res.data
            //     if (data.code == 200) {
            //         //将项目管理员 放在第一位
            //         this.cities = data.data
            //
            //         this.cities.forEach((item, index) => {
            //             if (item.roleName == '项目管理员') {
            //                 this.cities.splice(index, 1)
            //                 this.cities.push(item)
            //             }
            //         });
            //
            //         this.cities = this.cities.reverse() //数据倒叙展示
            //         this.delCites('92977b059f5811ec9b5652540055af6b')  //删除超级管理员
            //     }
            //     this.checkedCities = ['7d3b5b1d9f5811ec9b5652540055af6b'] //默认选中未分配
            //
            //     //禁用所有多选框,  选择项目信息后解禁
            //     for (let i = 0; i < this.cities.length; i++) {
            //         this.disabledStores.push(this.cities[i].roleId)
            //     }
            // })
        },

        //选中职位动作
        checkBox(event) {
            let toRoleId = '7d3b5b1d9f5811ec9b5652540055af6b' //未分配
            this.disabledStores = []    //解禁 未分配

            for (let i = 0; i < event.length; i++) {
                //如果选中的是 未分配, 将其他选中 变成 未选中
                if (event[event.length - 1] == toRoleId) {
                    this.checkedCities = []
                    this.checkedCities = [toRoleId]

                } else {
                    //否则, 将未分配 变成 未选中
                    for (let i = 0; i < this.cities.length; i++) {
                        if (this.cities[i].roleId == toRoleId) {
                            //因 未分配 与 其他选项 共选, 将 未分配 变为未选中
                            this.delCheckedCities(toRoleId)
                        }
                    }
                }
            }

            //所有选择框为空时, 选中 未分配
            if (0 == event.length) {
                this.checkedCities = [toRoleId]
            }
            
            //多选框 被选中, 选择职位 作用于多选框
            if (this.drag.right_multipleSelection.length != 0) {
                for(let i = 0; i < this.drag.right_multipleSelection.length; i++) {
                    this.checkedList[this.drag.right_multipleSelection[i].objectId] = this.checkedCities;
                }
            } else {
                //选择职位 作用于被选中
                //将 key: Project, val: 多选集合   存入
                this.checkedList[this.drag.project] = this.checkedCities;
            }

            //刷新权限信息
            this.fliterPermissionInfo(this.drag.project)
        },

        //删除临时岗位岗位
        delCheckedCities(roleId) {
            for (let i = 0; i < this.checkedCities.length; i++) {
                if (this.checkedCities[i] == roleId) {
                    this.checkedCities.splice(i, 1)
                }
            }
        },

        //删除岗位
        delCites(roleId) {
            for (let i = 0; i < this.cities.length; i++) {
                if (this.cities[i].roleId == roleId) {
                    this.cities.splice(i, 1)
                }
            }
        },

        //获取所有权限信息
        getPermissionInfo() {
            // axios.post(http.httpUrlRegAndLogin + 'getAllPermissionsInfo', null).then(res => {
            //     let data = res.data
            //     if (data.code == 200) {
            //         this.permissionInfo = data.data
            //     } else {
            //         this.$message.error(data.message)
            //     }
            // })
        },

        //过滤显示权限信息
        fliterPermissionInfo(objectId) {
            if (undefined == this.checkedList[objectId] || '7d3b5b1d9f5811ec9b5652540055af6b' == this.checkedList[objectId]) {
                this.permissionId = []
                this.permission = ['无权限']
                return false
            }
            //所拥有的权限, 合并 去重
            var arr = []
            this.checkedList[objectId].forEach((item, index) => {
                //筛选对应权限信息
                let data = {'id': 0, 'permissionId': '', 'roleId': item}
                
                axios.post(http.httpUrlRegAndLogin + 'selRolePermissionByRoleId', data).then(res => {
                    
                    if (res.data.code == 200) {
                        arr = arr.concat(JSON.parse(res.data.data.permissionId))
                        this.permissionId = [...new Set(arr)];
                        this.fliterPermissionInfo2()
                    }
                })
            });
            
        },
        fliterPermissionInfo2() {
            //过滤为 应显示的数据
            this.permission = []
            this.permissionInfo.forEach(info => {
                for (let i = 0; i < this.permissionId.length; i++) {
                    let infoId = this.permissionId[i]
                    
                    if (info.id == infoId) {
                        this.permission = this.permission.concat(info.name)
                    }
                }
            })
        },

        //保存信息
        submit () {
            //checkedList   未选择职位, 排除掉
            var res = []

            //选中 All
            if (true == this.checkedAll) {
                this.checkedCities.splice(0, 1)
                res = res.concat({'projectId': 'all', 'roleId': this.checkedCities})
            } else {
                //所属框 验证 未选择职位过滤掉
                this.drag.done.forEach((item, index) => {
                    if (undefined !== this.checkedList[item.objectId]) {
                        if ('7d3b5b1d9f5811ec9b5652540055af6b' != this.checkedList[item.objectId]) {
                            res = res.concat({"projectId": item.objectId, "roleId": this.checkedList[item.objectId]})
                        }
                    }
                })
            }
            //将选中 all 恢复为默认
            this.checkedAll = false

            if ('' == res) {
                res = {'projectId': '', 'roleId': '7d3b5b1d9f5811ec9b5652540055af6b'}
            }

            let data = { 'userId': this.userId, 'data': res}

            axios.post(http.httpUrlRegAndLogin + 'modifyRoleProjectInfo', data,{
                headers: {
                    'token': localStorage.getItem('token') + ''
                },
            }).then(res => {
                if (res.data.code == 200) {
                    this.$message.success(res.data.message)
                    //请求成功
                    this.getData(1)

                    //回到用户列表页
                    this.showContent = false
                    this.showList = true

                    
                } else {
                    this.$message.error(res.data.message)
                }
            })
        },

        //初始化密码
        initPassword() {
            // 二次确认
            this.$confirm('确定要初始化 '+ this.account +' 的密码？', '提示', {
                type: 'warning'
            }).then(() => {
                let data = {'id': this.userId}
                userAdminInitPassword(data).then(result => {
                    if (result.code !== 200) {
                        message.warning(result.message)
                        return
                    }
                    message.success("初始化成功")
                })
            })
        },

        //返回
        goBack() {
            this.$router.go(-1)
        },
    }
}
</script>


<style scoped lang="scss">
/* 鼠标悬浮 */
::v-deep.el-table--enable-row-hover .el-table__body tr:hover > td {
//  background-color: #212e3e !important;
    cursor: pointer;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
::v-deep.el-table__body tr.current-row > td{
background-color: #79BBFF !important;
}

// ------------------------------------- 布局 Begin
.grid-content {
    border-radius: 4px;
    min-height: 36px;
    p {
        line-height: 28px;
        font-size: 14px;
        color: #303133;
    }
    .cont {
        letter-spacing: 1px;
    }
}
//职位多选框
.grid-content-posi {
    margin-left: 6%;
    .el-radio {
        margin: 0 35px;
        line-height: 30px;
    }
}
//权限
.grid-content-perm {
    font-size: 14px;
    padding: 10px 15px;
    margin-left: 40px;
    line-height: 25px;
    color: #303133;
    min-height: 200px;
}
// ------------------------------------- 布局 End 
.plugins-tips {
    margin-left: 35px;
    padding-left: 30px;
}

.drag-box{
    display: flex;
    user-select: none;
    margin-left: 35px;
}
.drag-box-item {
    flex: 1;
    max-width: 330px;
    min-width: 300px;
    background-color: #eff1f5;
    margin-right: 16px;
    border-radius: 6px;
    border: 1px #e1e4e8 solid;

    .all-checkbox {
        font-size: 14px;
        line-height: 1.5;
        color: #24292e;
        font-weight: 600;
    }
}
.item-title{
    padding: 8px 8px 8px 12px;
    font-size: 14px;
    line-height: 1.5;
    color: #24292e;
    font-weight: 600;
}
.item-ul{
    padding: 0 8px 8px;
    height: 400px;
    overflow-y: scroll;
}
.item-ul::-webkit-scrollbar{
    width: 0;
}
</style>
